/* eslint-disable @typescript-eslint/promise-function-async */
import axios from 'axios';

import { getLanguage } from './i18next';

// 创建 Axios 实例
const api = axios.create({
    baseURL: process.env.APP_API ?? '/', // 设置基础 URL
    timeout: 10000, // 设置请求超时时间
    method: 'GET',
});

// 请求拦截器
api.interceptors.request.use(
    async (config: any) => {
        config.headers['Content-Type'] = 'application/json';
        config.headers['Accept-Language'] = config.language ?? getLanguage();
        // 为了国际化host修改，这里覆盖配置
        if (config.method.toUpperCase() === 'GET') {
            config.params = config.params || config.data;
            //
            delete config.data;
        }
        return config;
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 响应拦截器
api.interceptors.response.use(
    (response: any) => {
        // console.log('response', response.data?.code, response.data?.data);
        if (response.data?.code === 200) {
            return response.data?.data;
        }
        console.error(response.data?.msg);
        return Promise.reject(response.data);
    },
    (error) => {
        console.error('Error response:', error.response, error);
        return Promise.reject(error.response.data);
    }
);

export default api;
